import { ComponentType } from "react"

const Loading: ComponentType<{
  inline?: boolean
  small?: boolean
}> = ({
  inline = false,
  small = false
}) => {
    return (
      <div className={`loader loader-${inline ? 'inline' : 'overlay'}`}>
        <span className={`spinner  spinner-${small ? 'small' : ''}`} />
        {!inline && <p>Lade…</p>}
      </div>
    )
  }

export default Loading